<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title"><strong>CÁLCULO DE RETENÇÃO</strong></h3>
  </div>

  <div class="modal-body">
    <h3 class="mt-0">Valor Solicitado</h3>
    <p class="text-center">
      {{ proposta.valorLiquido | currency: 'BRL':'symbol':'1.2-2' }}
    </p>

    <h3>Parcelamento</h3>
    <p class="text-center">
      {{ parcela.numeroParcelas }}x de
      {{ parcela.valor | currency: 'BRL':'symbol':'1.2-2' }}
    </p>

    <h3>Retenção</h3>
    <p class="text-center">{{ parcela.percentualRetencao }}%</p>

    <h3>Valor Líquido</h3>
    <p class="text-center mb-0">
      {{ parcela.valorLiquido | currency: 'BRL':'symbol':'1.2-2' }}
    </p>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="bt-back btn btn-border-orange"
      (click)="close()"
    >
      Fechar
    </button>
  </div>
</div>
